<template>
    <div>
        <section class="xlrclh">
            <img
                class="top-img"
                src="./../assets/imgs/xllh/rcgyysq.png"
                alt=""
            />
            <div class="technological-process">
                <div class="zcjj">
                    <img
                        class="top"
                        style="height: 1.12rem"
                        src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des">
                            为进一步加大青年人才安居保障，提出“有意来蓉创新创业的各类人才，来蓉前即可线上进行人才公寓预申请，来蓉工作且符合安居资格的，购买人才公寓可享受政策面积8.5折优惠”。
                        </div>
                    </div>
                </div>
                <div class="sqdx mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/7/label1.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des">
                            有意来蓉创新创业的各类人才。
                        </div>
                    </div>
                </div>
                <div class="zcnr">
                    <img
                        class="top"
                        src="./../assets/imgs/7/label2.png"
                        alt=""
                    />
                    <div class="content">
                        通过人才安居资格预申请提前进行资格排序，待来蓉正式取得安居资格后，按安居资格预申请取得时间排序租购人才公寓。
                    </div>
                </div>
                <div class="bllc">
                    <img
                        class="top"
                        src="./../assets/imgs/xllh/sqlc_top.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="title" style="padding-top: 0.3rem;">
                            <span class="hollow-cricle"></span>
                            如何预申请“人才公寓” ？
                        </div>
                        <div class="des mar-t3">
                            <div class="describe-item">
                                符合条件的人才可自行登录成都人才安居服务网进行申请。
                                <br />
                                <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 0.3rem;">
                                    <img src="./../assets/imgs/7/code.png" style="width: 1.71rem;height: 1.78rem;" alt="">
                                    <img src="./../assets/imgs/7/info.png" style="width: 3.98rem;height: 1.12rem;" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sqdx mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/7/label4.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des" style="font-weight: bolder;font-size: 0.3rem;">
                            全年。
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img
                        class="top"
                        src="./../assets/imgs/7/label5.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61889280">028-61889280</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市住房和城乡建设局住房保障处
                        </div>
                    </div>
                </div>

                <!-- <bottom phone="028-61889280" unit="成都市住房和城乡建设局住房保障处"></bottom> -->
            </div>
        </section>
        <!-- <call site="https://zw.cdzjryb.com/talentsPlaceOuter/beforeApply/goApply" goIndex="2"></call> -->
        <call phone="028-61889280" site="https://zw.cdzjryb.com/talentsPlaceOuter/beforeApply/goApply"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        // bottom,
        call,
    },

    mounted() {},

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    padding-bottom: 0.1rem;

    .top-img {
        width: 7.26rem;
        height: 5.78rem;
    }

    .technological-process {
        transform: translateY(-1.83rem);

        .zcjj {
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;


                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .sqdx {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.1rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    text-align: left;
                    line-height: 0.44rem;
                }
            }
        }

        .zcnr {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .describe {
            background: linear-gradient(
                180deg,
                #ffffff 0%,
                rgba(255, 255, 255, 0) 100%
            );
            border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
            opacity: 1;
            padding: 0.33rem 0.33rem 0 0.15rem;

            .num {
                min-width: 0.39rem;
                height: 0.39rem;
                background: #739bfe;
                color: #ffffff;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
            }
        }

        .bllc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.25rem 0.23rem;

                    .require {
                        font-size: 0.34rem;
                        font-weight: bold;
                        color: #3d5aa3;
                        position: relative;
                        padding-left: 0.58rem;

                        .bllc11 {
                            width: 4.22rem;
                            height: 0.49rem;
                            position: absolute;
                            left: 0;
                        }

                        .bllc12 {
                            width: 3.31rem;
                            height: 0.49rem;
                            position: absolute;
                            left: 0;
                        }

                        .bllc21 {
                            width: 2.56rem;
                            height: 0.49rem;
                            position: absolute;
                            left: 0;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        // padding-left: 0.33rem;
                        // padding-top: 0.22rem;
                        // margin-left: 0.2rem;
                        word-break: break-all;
                        line-height: 0.44rem;
                    }
                }
            }
        }

    }
}
</style>
